import { Controller } from "@hotwired/stimulus"

// After a frame navigation with turbo-action="advance", Turbo files the snapshot under the
// pre-advance URL, so back/forward refetches the page instead of restoring the detached copy.
let restoring = false
document.addEventListener("turbo:visit", (event) => {
  restoring = event.detail.action === "restore"
})

export default class extends Controller {
  static values = { url: String }

  connect() {
    if (restoring || document.documentElement.hasAttribute("data-turbo-preview")) return

    // Turbo caches this page when leaving it and restores that copy on back/forward
    // without a request; detaching first keeps the restored copy from counting again.
    this.element.dataset.controller = this.element.dataset.controller
      .split(" ")
      .filter((identifier) => identifier !== this.identifier)
      .join(" ")

    fetch(this.urlValue, {
      method: "POST",
      keepalive: true,
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content },
    })
  }
}
